function assertString(input){if(input===undefined||input===null)throw new TypeError("Expected a string but received a ".concat(input));if(input.constructor.name!=="String")throw new TypeError("Expected a string but received a ".concat(input.constructor.name))}

export { assertString as default };
//# sourceMappingURL=assertString.js.map
